class CommonContants {
    static FIELD_DATE_FORMAT = 'MM/DD/YYYY';
    static LOADING_MESSAGE = "Please wait, we are loading the job's information";
    static JOB_ID_MESSAGE = "By selecting a job id, each input of the form is going to be auto-completed with the respective values of the selected job";
    static NO_JOB_MESSAGE = "No favourite jobs for ";
    static PROJECT_DESCRIPTION_MESSAGE = "Please enter a title for this packaging submission. E.G.; “Paid ads for our retail partner’s website” or “Influencer campaign for Back to School”";
    static LS_REF_MESSSAGE = "Please enter valid linesheet reference";
    static NOTES_MESSAGE = "Please provide additional context/notes about this submission for the BA team’s review";
    static LICENSEE_REF_MESSAGE = "Please, include the applicable Licensee Reference #";
    static RETAILER_SKU_MESSAGE = "Please, include the applicable Retailer SKU";
    static UPC_MESSAGE = "Please, include the applicable UPC as comma separated values";
    static ISBN10_MESSAGE = "Please, include the applicable ISBN-10/UPC";
    static ISBN13_MESSAGE = "Please, include the applicable ISBN-13";
    static IS_FAVORITE_MESSAGE = "Do you want to add this form to your favorites?";
};

export default CommonContants;